export const formatRounded = (
	value: number | string,
	precision = 2,
): number => {
	const numeric = Number(value);
	if (!Number.isFinite(numeric)) {
		return 0;
	}

	const factor = 10 ** precision;
	const rounded = Math.round(numeric * factor) / factor;

	return Number.isInteger(rounded)
		? Math.trunc(rounded)
		: Number(rounded.toFixed(precision));
};

export type RGBColor = {
	r: number;
	g: number;
	b: number;
};

export const incrementColorValue = (
	value: number,
	index: number,
	strength: number,
): number => {
	const result = Math.round(value + (255 - value) * (index * strength));
	return result >= 255 ? 255 : result;
};

export const incrementRGB = (color: RGBColor, index: number): RGBColor => ({
	r: incrementColorValue(color.r, index, 0.12),
	g: incrementColorValue(color.g, index, 0.12),
	b: incrementColorValue(color.b, index, 0.14),
});

export const generateColors = (
	baseColor: RGBColor,
	count: number,
): string[] => {
	const colors: string[] = [];
	for (let i = 0; i < count; i += 1) {
		const next = incrementRGB(baseColor, i);
		colors.push(`rgb(${next.r},${next.g},${next.b})`);
	}
	return colors;
};
